






































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { Team } from '@/models/admin/team';
import { AuthorizationHelper as _authorization } from '@/helper/authorization.helper';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import {getTeamListHeaders} from '@/views/admin/team/team';
import {teamService} from '@/shared';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
    components: {
        Grid: () => import('@/components/common/app.grid.vue'),
        Stores: () => import('@/components/common/store.select.vue'),
        AppDialog: () => import('@/components/common/app.dialog.vue'),
    },
})
export default class TeamListPage extends Base {
    public headers: VHeaders[] = getTeamListHeaders(this);
    public pagedTeams: Team[] = [];
    public pagination = new PaginationModel('name');
    public loading: boolean = false;
    public storeId: number;
    public actions: any[] = [];
    public deleteDialog: IDialogOption = {
        width: 400,
        title: this.$parent.$t('teams.deleteDialogTitle') as string,
        model: false,
        action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
        loading: false,
        onAction: (): void => {
            this.deleteTeam();
        },
    };
    public teamToDelete: Team = {
        id: '',
        name: '',
        users: [],
        selected: false,
    };
    public preventPaginationCall: boolean = false;
    public setActions() {
        this.actions = [
            {
                type: 'link',
                icon: 'fas fa-edit',
                title: this.$t('teams.teamGridHeaders.gridAction.edit') as string,
                action: (model: Team, storeId: string) => {
                    return {
                        name: 'admin.teams.edit',
                        params: {
                            id: model.id,
                            storeId: this.storeId,
                        },
                    };

                },
            }
            , {
                type: 'button',
                icon: 'fas fa-trash-alt',
                title: this.$t('teams.teamGridHeaders.gridAction.delete') as string,
                color: 'error',
                action: (model: Team, storeId: string) => {
                    this.confirmDelete(model);
                },
            }
            , {
                type: 'link',
                icon: 'fas fa-users',
                title: this.$t('teams.teamGridHeaders.gridAction.teamUser') as string,
                action: (model: Team, storeId: string) => {
                    return {
                        name: 'admin.teams.users',
                        params: {
                            teamId: model.id,
                            storeId: this.storeId,
                        },
                    };
                },
            },
        ];
    }

    public created() {
        if (this.$route.params.storeId) {
            this.storeId = Number(this.$route.params.storeId);
        } else {
            this.storeId = this.userSession.storeId;
        }
    }

    public beforeDestroy() {
        const buttons = [];
        this.$emit('updateToolBar', buttons);
    }
    public callMethod(methodName): void {
        if (methodName === 'addTeam') {
            this.$router.push({ name: 'admin.teams.add', params: { storeId: this.storeId.toString() } });
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({ id: '0', type: 'button', title: this.$t('teams.btnAddTeam'), disabled: false, visible: true, class: 'btn', label: this.$t('teams.btnAddTeam'), click: 'addTeam', icon: 'fas fa-plus-circle' });
        this.$emit('updateToolBar', buttons);
    }
    public mounted() {
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'teams');

        // Toolbar
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });
        if (!this.isAuthorizedToAccess(['SuperAdmin', 'T-Admin', 'E-Admin'])) {
            this.getTeams();
        }
        this.setActions();
    }
    public async getTeams(): Promise<void> {
        try {
            this.loading = true;
            const response = await teamService.getTeams(
                this.pagination,
                this.storeId,
            );
            this.pagedTeams = response.results || [];
            this.pagination.totalItems = response.total;
        } finally {
            this.loading = false;
        }
    }
    public updatePaging(paging: any) {
        this.pagination = paging;
    }
    public confirmDelete(item: Team): void {
        this.deleteDialog.model = true;
        this.teamToDelete = item;
    }
    public async deleteTeam(): Promise<void> {
        try {
            this.deleteDialog.loading = true;
            await teamService.deleteTeam(this.teamToDelete.id, this.storeId);
            this.deleteDialog.model = false;
            this.preventPaginationCall = true;
            this.showAlert(true, this.$t('teams.alertDeleteTeam'));
            this.getTeams();
        } finally {
            this.deleteDialog.loading = false;
        }

    }
    public updateStore(storeId: number): void {
        this.storeId = storeId;
        this.getTeams();
    }
}
